import { axios } from '@/services/axios';

export const updateSpecialNumber = (specialNumberData) => {
    return axios.put('/specialnumber/', specialNumberData);
};
